import { render, staticRenderFns } from "./eg_modal_header.vue?vue&type=template&id=f7823276&scoped=true&"
import script from "./eg_modal_header.vue?vue&type=script&lang=js&"
export * from "./eg_modal_header.vue?vue&type=script&lang=js&"
import style0 from "./eg_modal_header.vue?vue&type=style&index=0&id=f7823276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7823276",
  null
  
)

export default component.exports